import { combineReducers } from 'redux'
import moment from 'moment'

//Set moment as global to be able to use it in scripts
global.moment = moment;

/*function labels(state = {
    title:"Title",
    subtitle:"subtitle",
    athlete:"Athelete",
    distance:"xxx km",
    time:"00:00:00"
}, action){
    switch (action.type) {
        case 'CHANGE_LABEL':
            var obj={};
            obj[action.key]=action.value; 
            return Object.assign(state, obj);
        default:
            return state
    }
}*/

function app(state = {
    isCheckoutPopupOpen: false,
    isLoggedIn: false,
    userName: null,
    token: null,

    isFetching: false,
    didInvalidate: false,
    products: [],

    cart: []
}, action) {
    switch (action.type) {
        case 'LOGIN':
            return Object.assign({}, state, {
                isLoggedIn: true,
                token: action.token
            })
        case 'LOGOUT':
            return Object.assign({}, state, {
                isLoggedIn: false,
                token: null
            })
        case 'REQUEST_PRODUCTS':
            return {
                ...state,
                isFetching: true,
                didInvalidate: false,
            }
        case 'RECEIVE_PRODUCTS':
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                products: action.data,
                lastUpdated: action.receivedAt
            }
        case 'ADD_TO_CART':
            return {
                ...state,
                cart: state.cart.concat(action.product)
            }
        case 'REMOVE_FROM_CART':
            return {
                ...state,
                cart: state.cart.filter((item, i) => i !== action.index)
            }
        case 'EMPTY_CART':
            return {
                ...state,
                cart: []
            }
        default:
            return state
    }
}

function data(state = {
    isFetching: false,
    didInvalidate: false,
    activities: [],
    famousRaces: [],
    detailedActivity: null,
    selectedActivities: [],
    selectedIndices: [],
    selectedFamousActivities: [],
    selectedFamousIndices: []
}, action) {
    switch (action.type) {
        case 'REQUEST_ACTIVITIES':
        case 'REQUEST_FAMOUSRACES':
        case 'REQUEST_ACTIVITY':
            return {
                ...state,
                isFetching: true,
                didInvalidate: false,
            }
        case 'RECEIVE_ACTIVITIES':
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                activities: state.activities.concat(action.data),
                lastUpdated: action.receivedAt
            }
        case 'RECEIVE_FAMOUSRACES':
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                famousRaces: action.data.marathon,
                lastUpdated: action.receivedAt
            }
        case 'RECEIVE_ACTIVITY':
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                detailedActivity: action.data,
                lastUpdated: action.receivedAt
            }
        case 'SELECT_ACTIVITIES':
            return {
                ...state,
                selectedActivities: action.activities,
                selectedIndices: action.indices
            }

        case 'SELECT_FAMOUSACTIVITIES':
            return {
                ...state,
                selectedFamousActivities: action.activities,
                selectedFamousIndices: action.indices
            }
        default:
            return state
    }
}

function poster(state = {
    template: "singleRouteMap",
    style: {
        theme: "light",
        route: {
            color: "#2196f3",
            strokeWidth: 3
        }
    },
    layout: {
        format: "A3",
        /**
         * Not used
         * A4 : 210mm-297mm : 420px-594px Hauteur = Largeur * racine carrée de 2
         * A3 : 297mm-420mm : 594px-820px
         * 
         * Used
         * 12x16in = 30x40cm = 480x640px Formats used for Printful
         */
        height: 640,//594, 
        width: 480,//420,
        margin: 10
    },
    legend: {
        position: 'bottom',
        height: 79,
        spacer: 2
    },
    labels: {
        title: "Title",
        subtitle: "subtitle",
        athlete: "Athlete",
        distance: "",
        calculatedDistance: 0,
        time: "00:00:00"
    },
    data: null,
    unit: 'mi'//km or mi

}, action) {
    switch (action.type) {
        case 'CHANGE_LABEL':
            let labels = state.labels;
            labels[action.key] = action.value;
            return {
                ...state,
                labels: labels
            };
        case 'CHANGE_THEME':
            return {
                ...state,
                style: {
                    ...state.style,
                    theme: action.value
                }
            };
        case 'CHANGE_UNIT':
            return {
                ...state,
                unit: action.value
            };
        case 'CHANGE_ROUTESTYLE':
            let route = state.style.route;
            route[action.key] = action.value;
            return {
                ...state,
                style: {
                    ...state.style,
                    route: route
                }
            };
        case 'CHANGE_TEMPLATE':
            let margin = 50;
            let strokeWidth = state.style.route.strokeWidth;
            if (action.value === 'gridMap') {
                margin = 10;
                strokeWidth = 1
            }
            return {
                ...state,
                template: action.value,
                style: {
                    ...state.style,
                    route: {
                        ...state.style.route,
                        strokeWidth: strokeWidth
                    }
                },
                layout: {
                    ...state.layout,
                    margin: margin
                }
            };
        case 'RECEIVE_ACTIVITY':
            return {
                ...state,
                data: action.data
            }
        case 'SELECT_ACTIVITIES':
            return {
                ...state,
                data: action.activities,
            }
        case 'RECEIVE_FULLCONFIG':
            return action.data
        default:
            return state
    }
}

const rootReducer = combineReducers({
    app,
    poster,
    data
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js